import { DATA_LOADING_STATES, SUBSCRIPTION_STATUSES } from '@config/Consts';

export default {
  userSettings: {}, // ui module
  globalFiltersUpdating: {
    // Todo: We should work with WIDGET_LOGICAL_NAMES, but unit tests are failing
    agents: false,
    conversations: false,
  }, // ui module
  accountData: {
    dataStatus: DATA_LOADING_STATES.NONE,
    subscriptionsStatus: SUBSCRIPTION_STATUSES.NONE,
    agentGroups: {
      data: [],
      revision: null,
      dataUpdateRequired: true,
    },
    skills: {
      data: [],
      revision: null,
    },
    userManaged: {
      data: [],
      revision: null,
    },
    users: {
      data: [],
      revision: null,
    },
    statusReasons: {
      data: [],
      revision: null,
    },
  },
  accountSettings: {
    blockConsumerName: true,
    canConfigureManagerWorkspace: false,
    metricsConfiguration: {
      data: [],
      revision: null,
      version: '',
    },
  },
  useNewManagerApi: true,
  fetchResponseMetrics: true,
  enableIntents: true,
  enableIntentsFilter: false,
  amwVersion: null,
  widgetsSubscriptionsStatus: SUBSCRIPTION_STATUSES.NONE,
  displayErrorWindow: false,
  workspacePartialWidgets: false, // ui module?
  isModuleActive: false,
  useBotsGraphMock: false,
  botsGraphMock: {},
  presetsValidatedOnFirstLoad: false,
  showBotGraph: true, // ui module
  // move to alerts module
  dialogAlertItems: {},
  alertData: {},
};

